import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem;
  gap: 1rem;
  overflow: auto;
`
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`

export const Icon = styled.div``

export const Title = styled.span`
  font-size: ${(props) => props.theme.font.textcaption};
  color: #003e5f;
`

export const Content = styled.div``
